import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Radio from 'antd/es/radio';

import { type TaskTemplate } from '@mai/types';

const TemplateField = ({ field }: { field: TaskTemplate['fields'][0] }) => {
  const label = field.name.charAt(0).toUpperCase() + field.name.slice(1);

  return (
    <Form.Item
      key={field.name}
      label={label}
      name={['fieldValues', field.name]}
      rules={[
        {
          required: field.required,
          message: `${field.name} is required`,
        },
      ]}
    >
      {field.type === 'text' ? (
        <Input placeholder={`Enter ${field.name}...`} />
      ) : field.type === 'textarea' ? (
        <Input.TextArea
          placeholder={`Enter ${field.name}...`}
          autoSize={{ minRows: 6 }}
        />
      ) : field.type === 'number' ? (
        <Input type="number" placeholder={`Enter ${field.name}...`} />
      ) : (
        <Radio.Group>
          <Radio value={true}>Yes</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
      )}
    </Form.Item>
  );
};

export default TemplateField;
